import React, { useEffect, useState } from "react";
import { useAuthStore } from "../context/useAuthStore";
import AlertComponent from "./CargaComponents/AlertComponent";
import { urlServerAdmin } from "../utils/UrlServerAdmin";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import imageWelcomeLogin from "../assets/login-welcome.png";
import { Box, Modal, Typography } from "@mui/material";

// constantes
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
const MAX_ATTEMPTS = 4;

const Login: React.FC = () => {
  const { login }: any = useAuthStore();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [warningLogin, setWarningLogin] = useState(false);
  const [attemptedLogin, setAttemptedLogin] = useState(0);
  const [isBlocked, setIsBlocked] = useState(false);

  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState("");

  const [openModal, setOpenModal] = React.useState(false);

  //Modal de error al iniciar sesion
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);

  useEffect(() => {
    if (attemptedLogin > 0 && attemptedLogin < MAX_ATTEMPTS) {
      alert(
        `Te quedan ${
          MAX_ATTEMPTS - attemptedLogin
        } intentos de inicio de sesión.`
      );
    }
    if (attemptedLogin >= MAX_ATTEMPTS) {
      setIsBlocked(true);
      blockedUser();
    }
  }, [attemptedLogin]);

  const blockedUser = async () => {
    try {
      const response = await axios.post(`${urlServerAdmin}login-blockeduser`, {
        email,
      });
      if (response.status === 200) {
        alert(response.data.message);
        setError("Tu cuenta ha sido bloqueada. Contacta al soporte.");
      }
    } catch (error: any) {
      console.log(
        "Error al bloquear el usuario:",
        error.response?.data?.message || error.message
      );
    }
  };

  //Validacion de inputs
  const validateInputs = () => {
    const email = document.getElementById("email") as HTMLInputElement;
    const password = document.getElementById("password") as HTMLInputElement;

    let isValid = true;

    if (!email.value || !/^\S+@todoslossantos\.pe$/.test(email.value)) {
      setEmailError(true);
      setEmailErrorMessage("Ingrese un correo válido.");
      isValid = false;
    } else {
      setEmailError(false);
      setEmailErrorMessage("");
    }

    if (!password.value || password.value.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage(
        "La contraseña debe tener al menos 6 caracteres."
      );
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage("");
    }

    return isValid;
  };

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isBlocked) {
      alert("Tu cuenta está bloqueada. Contacta al soporte.");
      return;
    }

    if (!validateInputs()) {
      return;
    }
    setWarningLogin(false);

    const responseLogin=await login(email, password);

    if (responseLogin === undefined) {
      setWarningLogin(false);
      handleOpen();
      setError (null);
      return;
    }else if (responseLogin.code === "auth/invalid-credential") {
      setWarningLogin(true);
      handleOpen();
      setError ("Credenciales incorrectas, verifique su correo y contraseña");
    }else if (responseLogin.code === "auth/too-many-requests") {
      handleOpen();
      setError ("Has excedido el número de intentos de inicio de sesión. Por favor, espera unos minutos y vuelve a intentarlo.");
    }else if (responseLogin.code === "auth/user-not-found") {
      setWarningLogin(true);
      handleOpen();
      setError ("El usuario no existe, verifique su correo y contraseña");
    }else if (responseLogin.code === "auth/wrong-password") {
      setWarningLogin(true);
      handleOpen();
      setError ("La contraseña es incorrecta, verifique su correo y contraseña");
    } 
  };

  return (
    <div className="container-general-login d-flex flex-column justify-content-center align-items-center">
      <form
        className="form-login-container d-flex flex-column gap-3 justify-content-center align-items-center bg-white p-4 mt-5 mb-5 rounded"
        onSubmit={handleLogin}
      >
        <h2 className="text-center">
          Sistema de administración del aplicativo móvil Todos los Santos de
          Chota
        </h2>

        <img
          src={imageWelcomeLogin}
          alt="Bienvenido"
          className="img-fluid w-50"
        />
        <TextField
          id="email"
          label="Email"
          variant="outlined"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          error={emailError}
          className="w-100 text-black"
          required
        />
        {emailError && <p className="text-danger">{emailErrorMessage}</p>}
        <TextField
          id="password"
          label="Password"
          variant="outlined"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-100"
          error={passwordError}
          required
        />
        {passwordError && <p className="text-danger">{passwordErrorMessage}</p>}
        <Button
          type="submit"
          fullWidth
          color="success"
          variant="contained"
          onClick={validateInputs}
          className="w-75 text-white"
          sx={{ mt: 3, mb: 2, fontWeight: "bold" }}
        >
          Iniciar Sesión
        </Button>
      </form>

      {error && (
        <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Aviso
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            {error}
          </Typography>
        </Box>
      </Modal>
      )}
     
      {warningLogin && (
        <AlertComponent
          message={error || ""}
          onClose={() => setWarningLogin(false)}
          severety="error"
          enabled={warningLogin}
        />
      )}
    </div>
  );
};

export default Login;